import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorPanel } from '../../ErrorPanel';
import { Body } from 'breeze-intelligence-kit';
import { LearnMoreText } from './LearnMoreText';
import { useEnrichableObjectTypes } from '../../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Title = ({
  isContactEnrichment
}) => {
  if (isContactEnrichment) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentProperties.panel.error.notFoundContact.title"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "enrichmentProperties.panel.error.notFoundCompany.title"
  });
};
const Description = ({
  isContactEnrichment
}) => {
  const {
    contactLabelLowercase
  } = useEnrichableObjectTypes();
  if (isContactEnrichment) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Body, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.panel.error.notFoundContact.description",
          options: {
            objectType: contactLabelLowercase
          }
        })
      }), /*#__PURE__*/_jsx(Body, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.panel.error.notFoundContact.description2",
          options: {
            objectType: contactLabelLowercase
          }
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(Body, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentProperties.panel.error.notFoundCompany.description"
    })
  });
};
export const ErrorNotFound = ({
  errorId,
  isContactEnrichment,
  onSubmit
}) => {
  const illustration = isContactEnrichment ? 'contacts' : 'companies';
  return /*#__PURE__*/_jsx(ErrorPanel, {
    errorId: errorId,
    illustration: illustration,
    onSubmit: onSubmit,
    title: /*#__PURE__*/_jsx(Title, {
      isContactEnrichment: isContactEnrichment
    }),
    children: /*#__PURE__*/_jsxs(ErrorPanel.Body, {
      maxInlineSize: "55ch",
      children: [/*#__PURE__*/_jsx(Description, {
        isContactEnrichment: isContactEnrichment
      }), /*#__PURE__*/_jsx(LearnMoreText, {})]
    })
  });
};